import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree';

const ScheduleModel = types.model('ScheduleModel', {
    start: types.maybeNull(types.string),
    end: types.maybeNull(types.string),
});
const TrainingEventModel = types.model('TrainingEventModel', {
    title: types.maybeNull(types.string),
    startDate: types.maybeNull(types.string),
    endDate: types.maybeNull(types.string),
    // schedule: types.map(ScheduleModel),
    schedule: types.frozen({}),
    location: types.maybeNull(types.string),
    tags: types.array(types.string),
    detailsUrl: types.maybeNull(types.string),
    seatsLeft: types.maybeNull(types.number),
    totalSeats: types.maybeNull(types.number),
});

export type TypeTrainingEventModel = Instance<typeof TrainingEventModel>;

export default TrainingEventModel;
